$.fn.querystring = function () {
	var urlParams = {};
	(function () {
		var e;
		var decodedURIComponents = function (s) {
			return decodeURIComponent(s.replace(/\+/g, " "));
		};
		var querystring = window.location.search.substring(1);
		var regex = /([^&=]+)=?([^&]*)/g;

		while (e = regex.exec(querystring))
			urlParams[decodedURIComponents(e[1])] = decodedURIComponents(e[2]);
	})();

	return urlParams;
};